module.exports = __webpack_public_path__ + "img/ico_coinstore_regularpackages@3x.1de1d720.png";